module.exports = __webpack_public_path__ + "img/not_found.d088f1a1.svg";